module.exports = __webpack_public_path__ + "static/media/HCMM842.ad81cfe5.jpg";